import React, { useContext, useEffect, useState } from "react";
import {
    Table,
    Form,
    Accordion,
    Button,
    FloatingLabel,
    Modal
} from "react-bootstrap";
import { useParams } from "react-router";

import DeleteIcon from "../../../../../assets/img/Delete.png";
import UpArrowIcon from "../../../../../assets/img/up-arrow.png";
import DownArrowIcon from "../../../../../assets/img/down-arrow.png";

import ContextComponent from "../../../../AppContext";
import Utils from "../../../../Utils";

const EditFieldPage = ({ props }) => {
    let [admin, setAdmin] = useState(false);
    let [superAdmin, setSuperAdmin] = useState(false);
    const { siteid } = useParams();
    let [currSiteId, setCurrSiteId] = useState(siteid);

    let { setAlert, setLoadingState, setCanRedirectToLogin, userData } = useContext(ContextComponent);
    let tableData = props?.tableData || [];

    let editableField = props?.editableField || {};
    let editableFieldIndex = props?.editableFieldIndex || {};

    let setTableData = props?.setTableData || (() => { });
    let [fieldId, sefieldId] = useState(editableField?.id || "");
    let [fieldid, setFieldid] = useState(editableField?.fieldid || "");
    let [fieldcode, setFieldcode] = useState(editableField?.fieldcode || "");
    let [displayName, setDisplayName] = useState(editableField?.displayname || "");
    let FIELDTYPE = Utils.FIELD_TYPE || {};
    let [type, setType] = useState(editableField?.type);
    let [dbquery, setDbquery] = useState(editableField?.dbquery || "");
    let [activestatus, setActivestatus] = useState(editableField?.activestatus || false);
    let [required, setRequired] = useState(editableField?.required || false);
    let [keyValues, setKeyValues] = useState(editableField?.keyvalues || []);

    useEffect(() => {
      setAdmin(!!userData?.admin);
      setSuperAdmin(!!userData?.superAdmin);
    }, [admin, superAdmin, userData]);

    const hideModal = (e) => {
        props.setEditModalCanOpen(false);
    };

    const fieldidHandler = (e) => {
        setFieldid(e.currentTarget.value);
    };

    const fieldCodeHandler = (e) => {
        setFieldcode(e.currentTarget.value);
    };

    const displayNameHandler = (e) => {
        setDisplayName(e.currentTarget.value);
    };

    const fieldTypeHandler = (e) => {
        setType(e.currentTarget.value);
    };

    const dbqueryHandler = (e) => {
        setDbquery(e.currentTarget.value);
    };

    const activestatusHandler = (e) => {
        setActivestatus(e.currentTarget.checked);
    };

    const requiredHandler = (e) => {
        setRequired(e.currentTarget.checked);
    };

    const handleKeyValueInputChange = (index, field, value) => {
        const newData = [...keyValues];
        newData[index][field] = value;
        setKeyValues(newData);
    };

    const addRow = () => {
        setKeyValues([...keyValues, { key: '', value: '' }]);
    };

    const removeRow = (index) => {
        const newData = [...keyValues];
        newData.splice(index, 1);
        setKeyValues(newData);
    };

    const moveRow = (direction, index) => {
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        if (newIndex >= 0 && newIndex < keyValues.length) {
            const updatedKeyValues = [...keyValues];
            const temp = updatedKeyValues[index];
            updatedKeyValues[index] = updatedKeyValues[newIndex];
            updatedKeyValues[newIndex] = temp;
            setKeyValues(updatedKeyValues);
        }

    }

    const updateField = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Updating Field",
        });
        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Field updated successfully!",
                type: "success",
            });

            props.loadFreshFields(currSiteId);
        };
        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Field update failed",
                type: "danger",
            });
            console.log(err);
        };
        let fieldInfo = {
            fieldid,
            fieldcode,
            displayname: displayName,
            type,
            dbquery,
            activestatus,
            required,
            keyvalues: keyValues
        };

        // console.log("final Field data");
        // console.log(fieldInfo);
        // console.log("updating the Field")
        try {
            // debugger;
            // console.log(formData);
            Utils.updateFieldById(fieldId, fieldInfo).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => { }, [props.addModalCanOpen]);

    const handleClose = (e) => {
        props.setEditModalCanOpen(false);
    };


    return (
        <>
            <Modal centered show={props.editModalCanOpen} className="indi-medium-modal" onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Field</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="indi-add-form-wrapper d-flex flex-column">
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Field Id">
                                        <Form.Control
                                            type="text"
                                            className="indi-input-field"
                                            id="fieldid"
                                            defaultValue={fieldid}
                                            placeholder="Enter Field Id"
                                            autoComplete="off"
                                            onChange={fieldidHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Field Code">
                                        <Form.Control
                                            type="text"
                                            className="indi-input-field"
                                            id="fieldcode"
                                            defaultValue={fieldcode}
                                            placeholder="Enter Field Code"
                                            autoComplete="off"
                                            onChange={fieldCodeHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Display Name">
                                        <Form.Control
                                            as="textarea"
                                            className="indi-input-field"
                                            id="displayName"
                                            defaultValue={displayName}
                                            placeholder="Enter Display Name"
                                            autoComplete="off"
                                            onChange={displayNameHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Field Type">
                                        <Form.Select
                                            defaultValue={type}
                                            id="type"
                                            onChange={fieldTypeHandler}
                                            size="sm"
                                            className={`indi-input-field indi-input-select-field 
                                              ${(!admin && !superAdmin) ? "indi-disable" : ""}`}
                                        >
                                            {FIELDTYPE.map((field, index) => (
                                                <option value={field.value} key={index}>
                                                    {field.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Options (Separate with | symbol)">
                                        <Form.Control
                                            as="textarea"
                                            className="indi-input-field"
                                            id="dbquery"
                                            defaultValue={dbquery}
                                            placeholder="Enter DB query"
                                            autoComplete="off"
                                            onChange={dbqueryHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex row">
                                <div className="indi-add-form-item-input col">
                                    <Form.Check
                                        type="switch"
                                        className="indi-input-switch-field indi-input-field"
                                        id="activestatus"
                                        defaultChecked={activestatus}
                                        label="Active Status"
                                        onChange={activestatusHandler}
                                    />
                                </div>
                                <div className="indi-add-form-item-input col">
                                    <Form.Check
                                        type="switch"
                                        className="indi-input-switch-field indi-input-field"
                                        id="required"
                                        defaultChecked={required}
                                        label="Required"
                                        onChange={requiredHandler}
                                    />
                                </div>
                            </div>
                            <div className="indi-add-key-value-item d-flex flex-column">
                                <Accordion className="indi-data-table-wrapper" defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Key Values</Accordion.Header>
                                        <Accordion.Body>
                                            <Table responsive="sm">
                                                <thead className="indi-data-table-header">
                                                    <tr>
                                                        <th className="text-center">Key </th>
                                                        <th className="text-center">Value</th>
                                                        <th >Actions</th> {/* Add Actions column for delete button */}
                                                        <th >Order</th> {/* Add column for ordering */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {keyValues.map((row, index) => (
                                                        <tr key={index} className="indi-data-table-tr">
                                                            <td className="indi-data-table-td-fields-key-value text-center">
                                                                <div className="indi-data-table-wrapper d-flex indi-text-area-row">
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        className="indi-input-field"
                                                                        placeholder={"Enter key"}
                                                                        autoComplete="off"
                                                                        value={row.key}
                                                                        onChange={
                                                                            (e) =>
                                                                                handleKeyValueInputChange(
                                                                                    index,
                                                                                    'key',
                                                                                    e.target.value
                                                                                )
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-image0-name text-center">
                                                                <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        className="indi-input-field"
                                                                        placeholder={"Enter value"}
                                                                        autoComplete="off"
                                                                        value={row.value}
                                                                        onChange={
                                                                            (e) =>
                                                                                handleKeyValueInputChange(
                                                                                    index,
                                                                                    'value',
                                                                                    e.target.value
                                                                                )
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-image0-name">
                                                                <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                                    <img
                                                                        className="indi-w-20"
                                                                        src={DeleteIcon}
                                                                        alt="delete"
                                                                        onClick={() => removeRow(index)}
                                                                        style={{ cursor: 'pointer', width: '15px', margin: '0 5px' }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td >
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                    <img
                                                                        src={UpArrowIcon}
                                                                        alt="up"
                                                                        onClick={index > 0 ? () => moveRow('up', index) : null} // Conditionally set onClick
                                                                        style={{ cursor: index > 0 ? 'pointer' : 'not-allowed', width: '15px', margin: '0 5px', opacity: index > 0 ? '1' : '0' }} // Apply different styles based on condition
                                                                    />
                                                                    <img
                                                                        src={DownArrowIcon}
                                                                        alt="down"
                                                                        onClick={index < keyValues.length - 1 ? () => moveRow('down', index) : null} // Conditionally set onClick
                                                                        style={{ cursor: index < keyValues.length - 1 ? 'pointer' : 'not-allowed', width: '15px', margin: '0 5px', opacity: index < keyValues.length - 1 ? '1' : '0' }} // Apply different styles based on condition
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            <Button
                                                onClick={addRow}
                                                className="float-end"
                                                // size="sm"
                                                style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}
                                            >
                                                Add Row
                                            </Button>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                        <div className="indi-add-footer">
                            <div className="indi-add-page-footer-btn-wrapper float-right">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={hideModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={updateField}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default EditFieldPage;